module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"payTitulo":"Tax free","payText":"The Tax free service facilitates the return of VAT to customers who are not residents of European Union."},"es":{"payTitulo":"Tax free","payText":"El servicio Tax free facilita la devolución del IVA a los clientes no residentes en la Unión Europea."}}')
  delete Component.options._Ctor
}
